import { Link } from '@tanstack/react-router';
import { Card, EmptyState, MemoryCirclesEmpty, buttonVariants } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface TeamEmptyCardProps {
  /** Without a calendar Wundo cannot find any 1:1s, so the card offers to connect one. */
  noCalendar: boolean;
}

/** The Team page before Wundo knows of anybody the user has 1:1s with. */
export function TeamEmptyCard({ noCalendar }: TeamEmptyCardProps) {
  return (
    <Card className='flex flex-col items-center py-10'>
      <MemoryCirclesEmpty />
      <EmptyState
        className='pb-0'
        title={m.team_empty_title()}
        description={noCalendar ? m.team_empty_no_calendar_body() : m.team_empty_body()}
        action={
          noCalendar && (
            <Link
              to='/settings/connections'
              className={buttonVariants({ variant: 'quiet', size: 'sm' })}
            >
              {m.empty_connect_calendar()}
            </Link>
          )
        }
      />
    </Card>
  );
}
